


const config = window.config;

const header_config = [
    { id:"LocalExperimentID", title : "Local submitter ID", inputType:"select-experiment",
        description:"Select the Local Submiter ID. Note that you can submit several files under one experiment combination.",
        mandatory:true, selection : [], width :200
    },
    { id:"Participant_ID", title : "Participant ID ", inputType:"textReadOnly" ,
        description:"Participant ID for the phenotipic information.",
        mandatory:false, selection : [], width :150
    },
    { id:"ExperimentID", title : config.platform_label + " ID Experiment", inputType:"textReadOnly" ,
        description:"Experiment ID for which you will submit data.",
        mandatory:false, selection : [], width :200
    },
    { id:"File", title : "File", inputType:"fileMultiple",
        description:"Select the file(s) you will be uploading. Use CTRL to select more than one file at a time. If you do not have a local copy of your file(s), please make an empty file that has EXACTLY the same name as each file you wish to upload and select these files.",
        mandatory:false, selection : [], width :260
    },
    { id:"FileName", title : "File Name", inputType:"textReadOnly", description:"Accepted file suffixes:.bam,.fastq.gz,.fq.gz,.fastq.bz2,.fq.bz2",
        mandatory:true, selection : [], width :200
    },
    { id:"FileType", title : "File Type", inputType:"select", description:"Please select from dropdown list.", mandatory:true,
        selection : ["----","BAM","FASTQ","CRAM"], width :140
    },
    { id:"CramRef", title : "Cram Reference", inputType:"select",
      description:"Checksum for the Fasta Reference File used to generate the Cram File.", mandatory:false,
      selection : ["----"], width :480
    },
    { id:"SequencingStrategy", title : "Sequencing Strategy", inputType:"select", description:"Just Paired End is accepted.", mandatory:true,
        selection : ["----","paired"], width :200
    },
    { id:"ReadLength", title : "Read Length", inputType:"select", description:"Select the sequencing read length (or closest approximation).", mandatory:false,
        selection : ["----","50","75","100","150","200","250","other"], width :130
    },
    { id:"InstrumentModel", title : "Instrument Model", inputType:"select",
        description:"Indicate the instrument used. Contact " + config.platform_mail + " to create a new instrument model.",
        mandatory:false, selection : ["----","Unknown","Illumina HiSeq 2000","Illumina HiSeq 2500","Illumina X Ten"], width :250
    },
    { id:"SequencingCentre", title : "Sequencing Center", inputType:"select", description:"Contact with " + config.platform_mail + " to create a new Sequencing Centre.",
        mandatory:false, selection : [], width :150
    }
]


export default header_config
